import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IProductPageLayoutRequest) {
    (function(GridSize) {
        GridSize["GRID_SIZE_UNKNOWN"] = "GRID_SIZE_UNKNOWN";
        /**
     * Desktop is default in BE logic.
     */ GridSize["DESKTOP"] = "DESKTOP";
        /**
     * Mobile-size view will render less tiles.
     */ GridSize["MOBILE"] = "MOBILE";
    })(IProductPageLayoutRequest.GridSize || (IProductPageLayoutRequest.GridSize = {}));
    (function(LayoutSession) {
        LayoutSession["LAYOUT_SESSION_UNKNOWN"] = "LAYOUT_SESSION_UNKNOWN";
        LayoutSession["PART_OF_A_COLLECTION"] = "PART_OF_A_COLLECTION";
        LayoutSession["BOTTOM"] = "BOTTOM";
    })(IProductPageLayoutRequest.LayoutSession || (IProductPageLayoutRequest.LayoutSession = {}));
    IProductPageLayoutRequest.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(IProductPageLayoutRequest || (IProductPageLayoutRequest = {}));
export var IProductPageLayoutRequest;
